import { computed, Directive, inject, input } from '@angular/core';
import {
  DATA_CONFIG,
  DataConfigKey,
  isSocialKey,
} from '../../injection-tokens';

@Directive()
class DataConfigBaseDirective {
  field = input.required<DataConfigKey>({ alias: 'dataConfig' });
  dataConfig = inject(DATA_CONFIG);
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector -- intentional bare attribute name (`dataConfig`, not `appDataConfig`), consistent with open-new-tab.directive.ts's `openNewTab`; deliberate exception
  selector: 'span[dataConfig]',
  host: {
    '[innerText]': 'innerText()',
  },
})
export class DataConfigSpanDirective extends DataConfigBaseDirective {
  innerText = computed(() => {
    const field = this.field();
    const value = this.dataConfig[field];

    if (typeof value !== 'string') {
      return value.displayText;
    }

    if (field === 'phone') {
      return value.replace(/\d{1}(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    }

    if (field === 'email') {
      return value;
    }

    switch (field) {
      case 'paypalLink':
        return 'PayPal';
      case 'zelleLink':
        return 'Zelle';
      case 'cashAppLink':
        return 'Cash App';
      case 'venmoLink':
        return 'Venmo';
      default:
        return value;
    }
  });
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector -- same intentional bare `dataConfig` attribute name as DataConfigSpanDirective above
  selector: 'a[dataConfig]',
  host: {
    '[href]': 'href()',
  },
})
export class DataConfigAnchorDirective extends DataConfigBaseDirective {
  href = computed(() => {
    const field = this.field();
    let hrefPrefix = '';

    if (field === 'email') {
      hrefPrefix = 'mailto:';
    }

    if (field === 'phone') {
      hrefPrefix = 'tel:';
    }

    if (isSocialKey(field)) {
      return this.dataConfig[field].link;
    }

    return `${hrefPrefix}${this.dataConfig[field]}`;
  });
}
